import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  skillSheets: [],
  skillSheet: {}
};

// getters
export const getters = {
  skillSheets: state => state.skillSheets,
  skillSheet: state => state.skillSheet
};

// mutations
export const mutations = {
  [types.SKILL_SHEET.SKILL_SHEET](state, skillSheet) {
    state.skillSheets = skillSheet;
  },
  [types.SKILL_SHEET.SHOW_SKILL_SHEET](state, skillSheet) {
    state.skillSheet = skillSheet;
  }
};

// actions
export const actions = {
  async fetchSkillSheet({ commit }) {
    const response = await axios.get(api.SKILL_SHEET);
    commit(types.SKILL_SHEET.SKILL_SHEET, !response.data ? [] : response.data);
  },

  // eslint-disable-next-line
  async createSkillSheet({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.ADD_SKILL_SHEET, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async showSkillSheet({ commit }, employeeId) {
    const response = await axios.get(api.SHOW_SKILL_SHEET + "/" + employeeId);
    commit(types.SKILL_SHEET.SHOW_SKILL_SHEET, response.data);
  }
};
